<template>
	<div class="privacy-policy-container">
		<div v-html="getContent()"></div>
	</div>
</template>
<script>
import { translate } from '../../assets/translations';

export default {
	computed: {
		translation() {
			return translate(this.$store.state.language).privacyPolicy;
		}
	},
	methods: {
		getContent() {
			return this.translation.htmlContent +
			`
			<style>
			.privacy-policy-title {
				margin: 2em auto 1em;
				span {
					font-size: 0.8em;
					background-color: #253b6d;
					color: #ffffff;
				}

				hr {
					margin-top: -1px;
				}
			}
			.privacy-policy-text {
			  font-size: 0.7em;
    		text-align: justify;
				.content-text {
					color: #686868;
				}
			}
			</style>
			`
		}
	},
}
</script>
<style scoped>
.privacy-policy-container {
	width: 90%;
	margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/privacy-policy/PrivacyPolicy.vue